import { makeStyles } from "@material-ui/styles";

const possessionIndicatorStyles = makeStyles((theme) => ({
	ball: {
		width: "1.5vw",
		marginTop: 5,
		minWidth: 15,
		[theme.breakpoints.only("xs")]: {
			marginRight: 5
		}
	}
}));

export default possessionIndicatorStyles;
